import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InfoTileComponent} from '../../info-tile/info-tile.component';
import {PlacementService} from '@/services/placement.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-medication-stats',
    standalone: true,
    imports: [CommonModule, InfoTileComponent],
    templateUrl: './medication-stats.component.html',
    styleUrl: './medication-stats.component.scss'
})
export class MedicationStatsComponent implements OnChanges {
    @Input() placementId: number | null = null;

    medicationStats: any = {
        totalMedications: 0,
        expiredMedications: 0,
        active: 0,
        age: 0
    };

    constructor(
        private placementService: PlacementService,
        private toastr: ToastrService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['placementId'] && this.placementId) {
            this.getMedicationStats(this.placementId);
        }
    }

    getMedicationStats(placementId: number): void {
        this.placementService.getMedicationData(placementId).subscribe({
            next: (response) => {
                this.medicationStats = response;
            },
            error: (error) => {
                this.toastr.error('Failed to load medication summary.');
            }
        });
    }
}
